import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=0c4b5d8a&scoped=true&"
import script from "./FooterBlock.vue?vue&type=script&lang=js&"
export * from "./FooterBlock.vue?vue&type=script&lang=js&"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=0c4b5d8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b5d8a",
  null
  
)

export default component.exports